namespace $.$$ {
	export class $shm_hitalama_benchmarks_runner extends $.$shm_hitalama_benchmarks_runner {
		private handler?: (event:MessageEvent)=>void
		private busy=false
		private readonly search_event=new Event('click')
		private current_fixture?: {map:string,widget:string,dataset:string}
		private fixture_model?: $shm_hitalama_benchmarks_goods
		// Message commands are separate wire roots. Keep the fixture identity
		// between them even when the memoized channel has no subscribers.
		@ $mol_mem model(){return this.fixture_model??=new this.$.$shm_hitalama_benchmarks_goods}
		@ $mol_mem fixture(next?:{map:string,widget:string,dataset:string}){if(next)this.current_fixture=next;return this.current_fixture??null}
		@ $mol_mem listen(){
			// Keep UI preferences local to this document. The stock Storage probe
			// also writes a temporary key, which invalidates every parent local channel.
			const shadow=new Map<string,string|null>()
			this.$.$mol_state_local['native()']={
				getItem:key=>shadow.has(key)?shadow.get(key)!:localStorage.getItem(key),
				setItem:(key,value)=>{shadow.set(key,value)},
				removeItem:key=>{shadow.set(key,null)},
			}
			// Read the existing auth only. Never write auth, home or profile.
			// The stock getter writes localStorage even on a read. In another frame
			// that emits storage events and can temporarily unmount the parent UI.
			const key=localStorage.getItem('$giper_baza_auth')
			if(!key)throw Error('Для бенчмарка войдите в приложение')
			const auth=this.$.$giper_baza_auth.from(JSON.parse(key))
			this.$.$giper_baza_auth.current=()=>auth
			// This frame is offline; the parent application's sync is unchanged.
			this.$.$giper_baza_yard.masters=()=>[]
			this.handler=event=>{
				if(event.origin!==location.origin||event.source!==parent||event.data?.benchmark!=='hitalama-client-v1')return
				const message=event.data
				if(this.busy)return
				this.busy=true
				$mol_wire_async(this).execute(message)
					.then((value:unknown)=>this.reply(message.id,{value}),(error:unknown)=>{
						console.error('[benchmark step] runner error',error instanceof Error?error.stack:error)
						this.reply(message.id,{error:error instanceof Error?error.message:String(error)})
					})
					.finally(()=>{this.busy=false})
			}
			addEventListener('message',this.handler)
			parent.postMessage({benchmark:'hitalama-client-v1',id:'boot:'+this.$.$mol_state_arg.value('benchmark'),value:true},location.origin)
			return null
		}
		private reply(id:string,value:object){parent.postMessage({benchmark:'hitalama-client-v1',id,...value},location.origin)}
		content() {
			const fixture = this.fixture()
			if (!fixture) return []
			const app = this.$.$shm_hitalama_app.Root(0)
			// The benchmark mounts a map without the normal app shell. Fullscreen
			// still needs its reactive host and overlay in this iframe document.
			return [app.Maps().Book(fixture.map), app.Fullscreen(), app.Overlay_panel()]
		}
		view(){
			const fixture=this.fixture()!
			return this.$.$shm_hitalama_app.Root(0).Maps().Book(fixture.map).Widget(new $giper_baza_link(fixture.widget)).Sub() as $shm_hitalama_map_widget_float_table2
		}
		@ $mol_action mounted(){
			this.$.$mol_state_arg.value('map',this.fixture()!.map)
			return true
		}
		paint_ready(id:string){
			return new Promise<void>((resolve)=>{
				const ready=()=>{
					const node=document.getElementById(id)
					if(!node||node.querySelector('[mol_view_error]'))return false
					observer.disconnect()
					requestAnimationFrame(()=>requestAnimationFrame(()=>resolve()))
					return true
				}
				const observer=new MutationObserver(ready)
				observer.observe(document.body,{subtree:true,childList:true,attributes:true})
				ready()
			})
		}
		@ $mol_action execute(message:any):any{
			const model=this.model(),payload=message.payload
			if(message.command==='prepare'){
				model.config(payload)
				const fixture=$mol_wire_sync(model).prepare(false)
				this.fixture(fixture);this.mounted()
				return fixture
			}
			if(message.command==='attach'){
				$mol_wire_sync(model).attach(payload.config,payload.fixture)
				this.fixture(payload.fixture);this.mounted()
				if(model.dataset().record_count()!==payload.count)throw Error('Количество записей после F5 не совпало')
				$mol_wire_sync(this).paint_ready(this.view().dom_id())
				return true
			}
			if(message.command==='create'){
				for(let from=0;from<payload.count;from+=32){
					$mol_wire_sync(model).append([from,Math.min(from+32,payload.count)])
					this.$.$mol_wait_rest()
				}
				$mol_wire_sync(this).paint_ready(this.view().dom_id())
				if(model.dataset().record_count()!==payload.count)throw Error('Количество созданных записей не совпало')
				return true
			}
			if(message.command==='persist'){
				for(const land of model.write_lands())$mol_wire_sync(land).units_saving()
				for(const land of this.lands())$mol_wire_sync(land).units_saving()
				return true
			}
			if(message.command==='verify'){
				const dataset=model.dataset(),fields=dataset.fields()
				for(let index=payload.from;index<payload.until;++index){
					const record=dataset.record_at(index)!
					const object=model.object(index) as Record<string,any>
					const actual=record.values_for_query(fields)
					const expected=fields.map(field=>record.value_prepare(field,object[field.title()]))
					const different=fields.filter((field,col)=>JSON.stringify(actual[col])!==JSON.stringify(expected[col])).map(field=>field.title())
					if(different.length)throw Error(`Сохранённые свойства записи ${index} не совпали: ${different.join(', ')}`)
				}
				return true
			}
			const view=this.view()
			if(message.command==='verify-query'){
				const query=payload.metric==='cold'?'Aurora':'Vega'
				const expected=Array.from({length:payload.count},(_,index)=>index).filter(index=>
					payload.metric==='status'?index%3===1:$shm_hitalama_benchmarks_goods.product_name(index).includes(query)
				)
				const actual=view.filtered_indexes()
				if(actual.length!==expected.length||actual.some((index,position)=>index!==expected[position])){
					throw Error('Состав или порядок найденных записей не совпал')
				}
				return true
			}
			if(message.command==='cold'||message.command==='warm'){
				const query=message.command==='cold'?'Aurora':'Vega'
				if(!view.search_opened())view.search_toggle(this.search_event)
				view.search(query)
				const indexes=view.filtered_indexes()
				const expected=Array.from({length:payload.count},(_,index)=>index).filter(index=>$shm_hitalama_benchmarks_goods.product_name(index).includes(query)).length
				if(indexes.length!==expected)throw Error('Результаты поиска не совпали')
				$mol_wire_sync(this).paint_ready(view.dom_id())
				return {found:indexes.length}
			}
			if(message.command==='status'){
				view.search('')
				const col=view.col_ids().findIndex((_,index)=>view.col_settings_title(index)==='Status')
				view.Column_filter(col).value('major');view.Column_filter(col).mode('equals')
				const found=view.filtered_indexes().length
				if(found!==Math.floor((payload.count+1)/3))throw Error('Результат фильтра Status не совпал')
				$mol_wire_sync(this).paint_ready(view.dom_id())
				return {found}
			}
			if(message.command==='add'){
				const col=view.col_ids().findIndex((_,index)=>view.col_settings_title(index)==='Status')
				view.search('');view.Column_filter(col).mode('all')
				$mol_wire_sync(model).append([payload.count,payload.count+1])
				$mol_wire_sync(this).paint_ready(view.dom_id())
				if(model.dataset().record_count()!==payload.count+1)throw Error('Запись не добавлена')
				return true
			}
			throw Error('Неизвестная команда бенчмарка')
		}
		@ $mol_mem lands(){
			const model=this.model(),lands=new Set<$giper_baza_land>([model.map().land(),model.widget().land(),model.dataset().land()])
			for(const page of model.dataset().record_page_entries())lands.add(page.land)
			for(const link of model.dataset().record_index_links())lands.add(this.$.$giper_baza_glob.Land(new $giper_baza_link(link).land()))
			if(model.config().properties===10){lands.add(model.tags_widget().land());lands.add(model.tags_dataset().land())}
			return [...lands]
		}
		destructor(){if(this.handler)removeEventListener('message',this.handler)}
	}
}
